<template>
  <v-layout row wrap align-center>
    <v-flex xs5>
      <v-layout>
        <v-flex :style="'padding: 0 12px;'">
          <v-select
            v-model="lang"
            :items="languages"
            item-text="name"
            item-value="code"
            @input="changeLenguaje"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs6 offset-xs1>
      <v-layout>
        <v-flex text-xs-right>
          <span class="p-light">{{ $t('login.help') }} </span>
        </v-flex>
        <v-flex text-xs-right>
          <span class="p-light">{{ $t('login.privacity') }}</span>
        </v-flex>
        <v-flex text-xs-right>
          <span class="p-light">{{ $t('login.terms') }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return { lang: this.$store.state.auth.locale }
  },
  computed: mapState({ languages: ({ auth: { locales } }) => locales }),
  methods: {
    changeLenguaje(lang) {
      this.$store.commit('auth/changeLanguageUser', lang)
    }
  }
}
</script>
